import React, { useState, useEffect } from 'react'

// API
import { Tabs, Tab, Grid } from '@material-ui/core'
import moment from 'moment'
import { motion } from "framer-motion";
import API from '../../services/api'

// Base Page
import BasePage from '../basePage'

// Molecules
import {
  RelatorioAgenda,
  RelatorioCliente,
  RelatorioNotas,
  RelatorioPets,
  PackageReport,
  Downloads,
} from '../../components/molecules'

// Material.ui

// moment
import 'moment/locale/pt-br'
import { useLocation } from 'react-router-dom'

moment.locale('pt-br')

// import Relatorio from '../components/organisms/Relatorio'
import { ReportProvider } from '../../providers/report'
import { RoyaltyStatement } from './RoyaltyStatement'
import { PurchaseReport } from './PurchaseReport'
import { useQueryParam } from 'use-query-params'
import { useMenu } from '../../store/global/useMenu';
import { ChartNoAxesCombined } from 'lucide-react';

function RelatorioPage() {
  const [tab, setTap] = useQueryParam("tab");

  const menuSize = useMenu(st => st.data.size)


  // CONST RELATORIO AGENDAMENTOS
  const [infoPanelClient, setInfoPanelClient] = useState(null)

  // CONST RELATORIO CLIENTE
  const link = null
  const [reportCustomers, setReportCustomers] = useState(null)
  const [paginationCliente, setPaginationCliente] = useState(null)

  // CONST RELATORIO PETS
  const linkPets = null
  const [reportCustomersPets, setReportCustomersPets] = useState(null)
  const [paginationPets, setPaginationPets] = useState(null)
  const [infoPanelPets, setInfoPanelPets] = useState(null)

  // CONST RELATORIO PETS
  const linkPackageReport = null
  const [reportCustomersPackageReport, setReportCustomersPackageReport] =
    useState(null)
  const [paginationPackageReport, setPaginationPackageReport] = useState(null)
  const [infoPanelPackageReport, setInfoPanelPackageReport] = useState(null)


  const initialTab = !tab || tab === "agendamentos"

  const date = new Date()
  const primeiroDia = moment(
    new Date(date.getFullYear(), date.getMonth(), 1),
  ).format('YYYY-MM-DD')

  // GET RELATORIO CLIENTE
  const getReportsCustomers = async (currentePage = 1) => {
    try {
      const { data } = await API.get(
        `reports/customers?currentePage=${currentePage}&perPage=50`,
      )
      setReportCustomers(data?.results)
      setPaginationCliente(data?.pagination)
      setInfoPanelClient(data?.panel)
    } catch (err) {
      console.log('Erro:', err)
    }
  }

  // GET RELATORIO PETS
  const getReportsCustomersPets = async (currentePage = 1) => {
    try {
      const { data } = await API.get(
        `reports/pets?currentePage=${currentePage}&perPage=50`,
      )
      setReportCustomersPets(data?.results)
      setPaginationPets(data?.pagination)
      setInfoPanelPets(data?.panel)
    } catch (err) {
      console.log('Erro:', err)
    }
  }

  // GET RELATORIO PACOTES
  const getPackageReport = async (currentePage = 1) => {
    try {
      const { data } = await API.get(
        `/reports/packages?currentePage=${currentePage}&perPage=50`,
      )
      setReportCustomersPackageReport(data?.results)
      setPaginationPackageReport(data?.pagination)
      setInfoPanelPackageReport(data?.panel)
    } catch (err) {
      console.log('Erro:', err)
    }
  }

  useEffect(() => {
    getPackageReport()
    getReportsCustomers()
    getReportsCustomersPets()
  }, [])


  return (
    <ReportProvider>
      <BasePage pageTitle={<><ChartNoAxesCombined className='w-7 h-7' />Relatórios</>}>
        <motion.div className='flex flex-col pt-1.5 pr-4' initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          transition={{ duration: 0.3 }}>
          <Tabs
            value={tab || "agendamentos"}
            indicatorColor="primary"
            textColor="primary"
            onChange={(_, value) => setTap(value)}
            aria-label="disabled tabs example"
            style={{
              boxShadow: '0 6px 20px rgb(0 0 0 / 10%)',
              borderRadius: '7px',
            }}
          >
            <Tab label="AGENDAMENTOS" value="agendamentos" />
            <Tab label="CLIENTES" value="clientes" />
            <Tab label="PETS" value="pets" />
            <Tab label="PACOTES" value="pacotes" />
            <Tab label="MINHAS EXPORTAÇÕES" value="minhas-exportacoes" />
            <Tab label="COMPRAS" value="compras" />
            {/* <Tab label="NOTAS FISCAIS" value="4" /> */}
          </Tabs>

          {tab === "royalty-statement" && (
            <Grid container spacing={3} style={{ flex: 1, height: "100%" }}>
              <Grid item xs style={{ marginTop: "20px" }}>
                <RoyaltyStatement />
              </Grid>
            </Grid>
          )}

          {initialTab && (
            <RelatorioAgenda primeiroDia={primeiroDia} date={date} />
          )}

          {tab === "clientes" && (
            <RelatorioCliente
              pagination={paginationCliente}
              reportCustomers={reportCustomers}
              link={link}
              setReportCustomers={setReportCustomers}
              getReportsCustomers={getReportsCustomers}
              infoPanel={infoPanelClient}
            />
          )}

          {tab === "pacotes" && (
            <PackageReport
              pagination={paginationPackageReport}
              reportCustomers={reportCustomersPackageReport}
              link={linkPackageReport}
              setReportCustomers={setReportCustomersPackageReport}
              getReportsCustomers={getPackageReport}
              infoPanel={infoPanelPackageReport}
            />
          )}

          {tab === "minhas-exportacoes" && <Downloads setValue={setTap} />}

          {tab === "pets" && (
            <RelatorioPets
              pagination={paginationPets}
              reportCustomers={reportCustomersPets}
              link={linkPets}
              setReportCustomers={setReportCustomersPets}
              getReportsCustomers={getReportsCustomersPets}
              infoPanel={infoPanelPets}
            />
          )}

          {tab === "notas-fiscais" && (
            <RelatorioNotas primeiroDia={primeiroDia} date={date} link={link} />
          )}

          {tab === "compras" && (
            <Grid container spacing={3} style={{ flex: 1, height: "100%" }}>
              <Grid item xs style={{ marginTop: "20px" }}>
                <PurchaseReport />
              </Grid>
            </Grid>
          )}
        </motion.div>
      </BasePage>
      {/* <Relatorio /> */}
    </ReportProvider>
  )
}

export default RelatorioPage
